import { useMutation } from 'react-query';
import http from '../http';

// to create fave pass via merchant connect
const createFavePassViaMerchantConnect = ({
  mc_product,
}: CreateFavePassPayload) =>
  http.post<CreateFavePassPayload>('/v1/mc_products', mc_product);

export const useCreateFavePassViaMerchantConnect = () =>
  useMutation(createFavePassViaMerchantConnect);

export type CreateFavePassPayload = {
  mc_product: FormData;
};
